import React, { useState, useEffect, useRef } from "react";
import ReactMarkdown from "react-markdown";
import { useTranslation } from "react-i18next";
import LogoImage from "../../assets/img/lions.svg";
import AdelmaImage from "../../assets/img/adelmaNBG.png";
import "./ChatHistory.css";

const StreamingMessage = ({ content, isNewThread }) => {
  const [displayedContent, setDisplayedContent] = useState('');
  
  useEffect(() => {
    if (!content) return;
    setDisplayedContent(content);
  }, [content]);
  
  return (
    <div className="message-content streaming">
      <ReactMarkdown>{displayedContent}</ReactMarkdown>
    </div>
  );
};

const ChatHistory = ({ chatHistory, chatEndRef, handleUserScroll, isTyping }) => {
  const { t } = useTranslation();
  const [isNewThread, setIsNewThread] = useState(true);
  const threadIdRef = useRef(localStorage.getItem('threadId'));
  const [streamingContent, setStreamingContent] = useState('');
  const firstAssistantMessageRef = useRef(false);
  const lastMessageRef = useRef(null);
  
  useEffect(() => {
    const currentThreadId = localStorage.getItem('threadId');
    if (currentThreadId !== threadIdRef.current) {
      threadIdRef.current = currentThreadId;
      setIsNewThread(true);
      firstAssistantMessageRef.current = false;
      lastMessageRef.current = null;
      setStreamingContent('');
    }
  }, []);

  useEffect(() => {
    if (chatHistory.length > 0) {
      const lastMessage = chatHistory[chatHistory.length - 1];
      if (lastMessage.role === 'assistant') {
        setStreamingContent(lastMessage.content);
        if (!firstAssistantMessageRef.current) {
          firstAssistantMessageRef.current = true;
        }
      }
    }
  }, [chatHistory]);

  const shouldStreamMessage = (message, index) => {
    const isLastMessage = index === chatHistory.length - 1;
    const isAssistantMessage = message.role === 'assistant';
    const isNewMessage = lastMessageRef.current !== message.content;
    
    if (isLastMessage && isAssistantMessage && (isNewMessage || isNewThread)) {
      lastMessageRef.current = message.content;
      return true;
    }
    return false;
  };

  return (
    <div className="chat-history" onScroll={handleUserScroll}>
      <div className="assistant-info">
        <picture>
          <source srcSet={AdelmaImage} type="image/png" />
          <img src={AdelmaImage} alt="Adelma hotel" className="assistant-avatar" />
        </picture>
        <h2>Adelma AI</h2>
        <p>{t("welcome")}</p>
      </div>
      
      {chatHistory.map((message, index) => (
        <div key={index} className={`chat-message ${message.role}`}>
          {message.role === "assistant" && (
            <img src={AdelmaImage} alt="Avatar" className="avatar" />
          )}
          {shouldStreamMessage(message, index) ? (
            <StreamingMessage 
              content={streamingContent} 
              isNewThread={isNewThread}
            />
          ) : (
            <div className="message-content">
              <ReactMarkdown>{message.content}</ReactMarkdown>
            </div>
          )}
        </div>
      ))}
      
      {isTyping && (
        <div className="chat-message assistant">
          <img src={AdelmaImage} alt="Avatar" className="avatar" />
          <div className="typing-indicator">
            <div className="typing-dot" aria-hidden="true"></div>
            <div className="typing-dot" aria-hidden="true"></div>
            <div className="typing-dot" aria-hidden="true"></div>
          </div>
        </div>
      )}
      <div ref={chatEndRef}></div>
    </div>
  );
};

export default ChatHistory;
